/**
 * Offer group visibility toggling module.
 * Controls visibility of form sections based on selected offer group (Accommodation/Transport/Insurance).
 */

export interface OfferGroupSections {
    transportSection?: HTMLElement | null;
    insuranceSection?: HTMLElement | null;
    profileImageSection?: HTMLElement | null;
    contactFieldsSection?: HTMLElement | null;
}

export interface OfferGroupConfig {
    populateInsuranceDropdowns?: () => void;
}

function setInputsDisabled(section: HTMLElement | null | undefined, disabled: boolean) {
    if (!section) return;
    section.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
        'input, select, textarea'
    ).forEach(el => { el.disabled = disabled; });
}

function showSection(section: HTMLElement | null | undefined, show: boolean) {
    if (!section) return;
    section.style.display = show ? 'block' : 'none';
    setInputsDisabled(section, !show);
}

/**
 * Apply group-specific visibility rules to form sections.
 * Hidden sections have their inputs disabled so they are excluded from form submission.
 */
export function applyGroupVisibility(selectedGroup: string, sections: OfferGroupSections, config?: OfferGroupConfig) {
    const { transportSection, insuranceSection, profileImageSection, contactFieldsSection } = sections;

    // Transport price section (Create) or transport fields (Edit)
    showSection(transportSection, selectedGroup === 'Transport');

    // Insurance section
    const showInsurance = selectedGroup === 'Insurance';
    showSection(insuranceSection, showInsurance);
    if (showInsurance && config?.populateInsuranceDropdowns) {
        config.populateInsuranceDropdowns();
    }

    // Profile image section (only for Accommodation)
    showSection(profileImageSection, selectedGroup === 'Accommodation' || selectedGroup === '');

    // Contact fields (hidden for Insurance)
    showSection(contactFieldsSection, selectedGroup !== 'Insurance');
}
